import "./style.scss";

export default function ImageContainer({ mobileImg, desktopImg, children }) {
  return (
    <div className="image-container">
      <div className="img-wrapper">
        <picture>
          <source media="(min-width: 1020px)" srcSet={desktopImg} />

          <img src={mobileImg} alt="glo-devices" />
        </picture>
      </div>
      <div className="content">{children}</div>
    </div>
  );
}
